import { Component, input, output } from '@angular/core';
import { WheelBonus } from '../../models/wheel-of-fortune.model';

@Component({
  selector: 'app-wheel-bonus-card',
  standalone: true,
  imports: [],
  templateUrl: './wheel-bonus-card.component.html',
  styleUrl: './wheel-bonus-card.component.scss'
})
export class WheelBonusCardComponent {
  public data = input.required<WheelBonus>();

  public balance = input<number>(0);

  public buySpins = output<WheelBonus>();

  public initSpinBuy() {
    this.buySpins.emit(this.data());
  }
}
